import { BaseChainsHeader } from 'domains/chains/components/BaseChainsHeader';
import { ChainsList } from 'modules/common/components/ChainsList';
import { ChainsPrivateStatsProvider } from 'modules/chains/components/ChainsPrivateStatsProvider';
import { UpgradeToPremiumPlanDialog } from 'modules/common/components/UpgradeToPremiumPlanDialog';
import { selectIsPremium } from 'modules/accountStatus/store/selectors';
import { selectUserEndpointToken } from 'modules/account/store/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { BaseChains } from '../BaseChains';
import { IChainsViewProps } from '../PublicChains/PublicChainsTypes';
import { PrivateChainsTop } from './components/PrivateChainsTop';
import { ProcessedChains } from './components/ProcessedChains';
import { privateChainsTranslation } from './translation';
import { usePrivateChains } from './hooks/usePrivateChains';

export const PrivateChains = ({
  chainsViewTabs,
  selectedChainsViewTab,
}: IChainsViewProps) => {
  const userEndpointToken = useAppSelector(selectUserEndpointToken);

  const isPremium = useAppSelector(state =>
    selectIsPremium(state, { userEndpointToken: userEndpointToken! }),
  );

  const {
    isPublicChainsChecked,
    loading,
    onPublicChainsCheckboxClick,
    processedChains,
    projects,
    projectsLoading,
    projectsWithChains,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    statsParams,
    timeframe,
  } = usePrivateChains();

  const {
    isOpened: isPromoDialogOpened,
    onClose: onPromoDialogClose,
    onOpen: onPromoDialogOpen,
  } = useDialog();

  const { keys, t } = useTranslation(privateChainsTranslation);

  return (
    <>
      <BaseChains loading={loading} top={<PrivateChainsTop />}>
        <BaseChainsHeader
          sortType={sortType}
          setSortType={setSortType}
          searchContent={searchContent}
          setSearchContent={setSearchContent}
          chainsViewTabs={chainsViewTabs}
          selectedChainsViewTab={selectedChainsViewTab}
          isPublicChainsChecked={isPublicChainsChecked}
          onPublicChainsCheckboxClick={onPublicChainsCheckboxClick}
        />
        <ChainsList
          hasNoResult={processedChains?.length === 0}
          isLoading={loading}
          timeframe={timeframe}
          tooltipText={t(keys.requestsTooltip)}
          view={selectedChainsViewTab?.id}
        >
          <ChainsPrivateStatsProvider value={statsParams}>
            <ProcessedChains
              hasPremium={isPremium}
              onPromoDialogOpen={onPromoDialogOpen}
              processedChains={processedChains}
              projects={projects}
              projectsLoading={projectsLoading}
              projectsWithBlockchains={projectsWithChains}
              timeframe={timeframe}
              view={selectedChainsViewTab?.id}
            />
          </ChainsPrivateStatsProvider>
        </ChainsList>
      </BaseChains>
      <UpgradeToPremiumPlanDialog
        isPromoDialogOpened={isPromoDialogOpened}
        onPromoDialogClose={onPromoDialogClose}
      />
    </>
  );
};
